exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DateRangePicker__DateRangePicker,\n.DS__DateRangePicker__Value,\n.DS__DateRangePicker__datepicker {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__DateRangePicker__DateRangePicker {\n  display: block;\n  width: 288px;\n}\n\n.DS__DateRangePicker__Value {\n  display: flex;\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.DS__DateRangePicker__datepicker {\n  display: block;\n  padding-bottom: 16px;\n}\n\n@media (max-width: 767px) {\n  .DS__DateRangePicker__Value {\n    display: flex;\n  }\n\n    .DS__DateRangePicker__Value > div:first-child {\n      margin-right: 16px;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"DateRangePicker": "DS__DateRangePicker__DateRangePicker",
	"Value": "DS__DateRangePicker__Value",
	"datepicker": "DS__DateRangePicker__datepicker"
};